import AddressOption from '@components/order/models/edit/AddressOption';
import UserAddress from '@components/user-address/models/UserAddress';
import EditLocationTwoToneIcon from '@mui/icons-material/EditLocationTwoTone';
import LocationOnTwoToneIcon from '@mui/icons-material/LocationOnTwoTone';
import { Box, Button, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import AddressOptionBaseButton from './AddressOptionBaseButton';

interface UserAddressOptionListItemProps {
    userAddress: UserAddress | undefined;
    value: AddressOption;
    selectedValue: AddressOption;
    onClick: (addressOption: AddressOption) => void;
    onUserAddressEditClick: () => void;
    disabled: boolean;
}

const UserAddressOptionListItem: React.FC<UserAddressOptionListItemProps> = observer(({ onUserAddressEditClick, userAddress, value, selectedValue, onClick, disabled }) => {
    var isSelected = "user-address" === selectedValue;

    const handleOnUserAddressClick = (addressOption: AddressOption) => {
        if (userAddress === undefined) {
            onUserAddressEditClick();
        }
        onClick(addressOption);
    }

    return (
        <AddressOptionBaseButton value={value} selectedValue={selectedValue} onClick={handleOnUserAddressClick} disabled={disabled}>
            <Box flexGrow={1} display={"flex"} flexDirection={"row"} justifyContent={"flex-start"} alignItems={"center"} textAlign={"left"}>
                <LocationOnTwoToneIcon color={isSelected ? "secondary" : "action"} />
                <Box ml={1} pr={2} display={"flex"} flexDirection={"column"}>
                    <Typography variant='subtitle2'>{userAddress?.address ?? "Unesi adresu dostave"}</Typography>
                    <Typography variant='caption' color={"text.secondary"}>{userAddress?.locationDescription}</Typography>
                </Box>
            </Box>
            <Button
                size="small"
                color='secondary'
                onClick={onUserAddressEditClick}
                disabled={disabled}
                sx={(theme) => ({
                    bgcolor: theme.palette.secondary.main,
                    position: "absolute",
                    right: 0,
                    top: 0,
                    height: "100%",
                    borderRadius: 0.5,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    minWidth: 0,
                    width: 40,
                    ":hover": {
                        bgcolor: theme.palette.secondary.dark
                    },
                })}>
                <EditLocationTwoToneIcon sx={{ color: "#fff" }} />
            </Button>
        </AddressOptionBaseButton>
    )
})

export default UserAddressOptionListItem;